import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { MfaBackupCodesModule } from '@lsq-frontend/fasttrack-shared/features/mfa-backup-codes';
import { QRCodeModule } from 'angularx-qrcode';
import { EulaPageComponent } from './eula/eula-page.component';
import { LoginPageComponent } from './login-page.component';
import { BackupCodeComponent } from './login-steps/backup-code.component';
import { ForcedResetPasswordComponent } from './login-steps/forced-reset-password.component';
import { ForgotPasswordVerificationComponent } from './login-steps/forgot-password-verification.component';
import { ForgotPasswordComponent } from './login-steps/forgot-password.component';
import { MfaCodeComponent } from './login-steps/mfa-code.component';
import { SignInComponent } from './login-steps/sign-in.component';
import { TroubleSigningInModalComponent } from './login-steps/trouble-signing-in-modal.component';
import { MfaRegistrationComponent } from './login-steps/mfa-registration.component';
import { SMSMfaRegistrationComponent } from './login-steps/sms-mfa-registration.component';
import { TotpMfaRegistrationComponent } from './login-steps/totp-mfa-registration.component';
import { LoginService } from './login.service';

@NgModule({
    imports: [LsqCommonModule.forChild(), MfaBackupCodesModule, QRCodeModule],
    exports: [],
    declarations: [
        LoginPageComponent,
        SignInComponent,
        MfaCodeComponent,
        MfaRegistrationComponent,
        SMSMfaRegistrationComponent,
        TotpMfaRegistrationComponent,
        BackupCodeComponent,
        ForgotPasswordComponent,
        ForgotPasswordVerificationComponent,
        ForcedResetPasswordComponent,
        TroubleSigningInModalComponent,
        EulaPageComponent
    ],
    providers: [LoginService]
})
export class LoginModule {}
